module.exports = __webpack_public_path__ + "static/media/order.ea5b633e.svg";